'use strict';

module.exports = function (value) {
	if (value == null) throw new TypeError("Cannot use null or undefined");
	return value;
};



//////////////////
// WEBPACK FOOTER
// ./~/event-emitter/~/es5-ext/object/valid-value.js
// module id = 23
// module chunks = 0